import { BRAND } from './constants';

export function brl(v) {
  return 'R$ ' + Math.round(Number(v) || 0).toLocaleString('pt-BR');
}

export function brlThousand(v) {
  return 'R$ ' + Math.round((Number(v) || 0) / 1000) + 'k';
}

export function numberBR(v) {
  return Math.round(Number(v) || 0).toLocaleString('pt-BR');
}

export function pctBR(v, decimals = 1) {
  return Number(v || 0).toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }) + '%';
}

const MONTH_ABBREVIATIONS = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

/**
 * Formata um mês no formato `AAAA-MM` (o jeito que o mock/API manda — fácil
 * de ordenar e interpretar no backend, ex.: `ORDER BY month`) como o rótulo
 * amigável usado nos eixos dos gráficos, ex.: `2025-08` → `ago/25`. É só
 * apresentação — os dados continuam ordenados pelo valor original.
 */
export function formatMonthLabel(month) {
  const [year, monthNumber] = String(month).split('-');
  const abbrev = MONTH_ABBREVIATIONS[Number(monthNumber) - 1] || monthNumber;
  return `${abbrev}/${year.slice(2)}`;
}

/**
 * Colunas agrupadas "vs. mês anterior" / "vs. ano anterior" usadas nas
 * tabelas de ranking (produtos, fornecedores, compradores). Cada linha do
 * dataSource precisa ter `approved` (valor atual) e os campos de variação
 * percentual `monthChangePct`/`yearChangePct` — o valor anterior é
 * reconstruído a partir do valor atual e da variação percentual.
 *
 * `h` é o `this.$createElement` do componente que monta as colunas.
 */
export function buildDeltaColumns(h) {
  const num = (text, color) => h(
    'span',
    { style: { fontWeight: 600, fontSize: '11px', whiteSpace: 'nowrap', color: color || BRAND.preto } },
    text,
  );

  const group = (title, key) => ({
    title,
    align: 'center',
    children: [
      {
        title: 'Valor',
        dataIndex: 'approved',
        align: 'right',
        width: 108,
        customRender: (_, row) => num(brl(row.approved / (1 + row[key] / 100))),
      },
      {
        title: 'Variação',
        dataIndex: 'approved',
        align: 'right',
        width: 108,
        customRender: (_, row) => {
          const prev = row.approved / (1 + row[key] / 100);
          const diff = row.approved - prev;
          const sign = diff >= 0 ? '+' : '-';
          return num(sign + brl(Math.abs(diff)), diff >= 0 ? BRAND.verde : BRAND.vermelho);
        },
      },
      {
        title: '%',
        dataIndex: key,
        align: 'right',
        width: 74,
        customRender: (_, row) => {
          const v = row[key];
          const sign = v >= 0 ? '+' : '-';
          return num(sign + pctBR(Math.abs(v)), v >= 0 ? BRAND.verde : BRAND.vermelho);
        },
      },
    ],
  });

  return [group('vs. mês anterior', 'monthChangePct'), group('vs. ano anterior', 'yearChangePct')];
}
